<template>
	<div>
		<h4 class="text-center">Agency Payment</h4>
		<b-form-row>
			<b-form-group class="col-md-2"  label="Criterio busqueda *">
				<b-form-select size="sm" v-model="filters.dateCriteria" :options="optionsCriteriaDates" > </b-form-select>
			</b-form-group>
			<b-form-group class="col-md-2" label="Fecha desde *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.startDate}"
						reset-button
						size="sm"
						v-model="filters.startDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-2" label="Hasta *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.endDate}"
						reset-button
						size="sm"
						v-model="filters.endDate"
				/>
			</b-form-group>

			
			<b-form-group class="col-lg-3" label="Canal de venta">
				<GroupedSalesChannelsSelect
					v-model="filters.salesChannelId"
					placeholder="Todos"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Estado de servicio">
				<multiselect
						:class="{'active-filter':filters.status.length>0}"
						v-model="filters.status"
						:options="statusOpts"
						group-label="group"
						group-values="options"
						group-select
						multiple
						label="text"
						track-by="value"
						placeholder="Todos"
						taggable
				/>
			</b-form-group>

		</b-form-row>

		<b-form-row>
			<b-overlay :show="loadingExport"  no-wrap rounded> </b-overlay>
			<b-col class="text-right mt-2" >
				<b-button v-if="$hasPermission('report.show')" @click="search()" variant="primary" class="mr-2"><md-icon icon="search"/> Generar</b-button>
				<b-button v-if="$hasPermission('report.export.xls')" @click="excel()" variant="success" class="mr-2"><md-icon icon=""/>Xls</b-button>
				<b-button v-if="$hasPermission('report.export.pdf')"   @click="pdf()" variant="danger" class="mr-2"><md-icon icon="picture_as_pdf"/></b-button>
			</b-col>
		</b-form-row>


		<b-row v-if="loading">
			<div >
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
			</div>
		</b-row>
		<b-row  v-if="!loading" >
			<b-col class="col-md-12">
				<div id="msg">
					<h6 v-if="totalRecords===-1">Seleccione las opciones para generar el reporte</h6>
					<h6 v-if="totalRecords>0">Se encontrarón {{totalRecords}} rides</h6>
					<h6 v-if="totalRecords===0">No se encontraron registros</h6>
				</div>
				<div class="table-responsive async-tables" v-if="totalRecords>0">
					<b-table  hover v-html="html">

					</b-table>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import api from '../../../../api.js'
	import Multiselect from 'vue-multiselect';
	import GroupedSalesChannelsSelect from "../../../helpers/GroupedSalesChannelsSelect";
	export default {
		name: "sales-channel-payments",
		components:{Multiselect,GroupedSalesChannelsSelect},
		data(){
			return {
				loading:false,
				loadingExport:false,
				html:"",
				totalRecords:-1,
				codeReport : "sales-channel-payments",
				filters:{
					status:[],
					startDate:"",
					endDate:"",
					salesChannelId:[],
					dateCriteria:'service-date'
				},
				optionsCriteriaDates:[
					{ text: 'Por fecha de servicio', value: 'service-date'},
					{ text: 'Por fecha de reserva', value: 'reservation-date' },
				]
			}
		},
		methods:{
			search(){
				this.loading = true
				this.html= "";
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters
					}
				}).then((res) => {
					this.totalRecords = res.data.totalRegistros??0;
					this.html = (this.totalRecords)?res.data.html:"";
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loading = false});

			},

			excel(){
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters,
						format:"excel"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadExcel(res,"Remittance-payment");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});

			},
			pdf(){
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters,
						format:"pdf"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadPdf(res,"Remittance-payment");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});////

			}
		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['salesChannelsOpts']})
		},
		computed:{
			channelOpts(){
				let aux= [...this.$root.auxVars.salesChannelsOpts];
				return aux;
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts}]
			}
		}

	}
</script>

<style scoped>

</style>
